export const SKINS = [
  "color",
  "dark",
  "mono",
  "matrix",
  "dracula",
  "alien",
  "y2k",
  "neoy2k",
  "aquarium",
  "winamp",
  "macos",
  "maximalist",
];

export const SKIN_LABELS = {
  // The default look. Named "None" so it reads as "no skin applied",
  // matching the None that leads Moods. The stored value stays `color`.
  color: "None",
  // slowed.app's dark theme: black page, the same pinks.
  dark: "Dark",
  // The grey look that was called Dark until 0.12.0. The stored value never
  // changed, so anyone who picked it keeps it, under its new name.
  mono: "Mono",
  winamp: "Winamp 2.0",
  macos: "Classic Mac",
  y2k: "Y2K",
  neoy2k: "Neo-Y2K",
  matrix: "Matrix",
  aquarium: "Aquarium",
  dracula: "Dracula",
  alien: "Alien",
  maximalist: "Maximalist",
};

export function resolveSkin(config) {
  // Retired WMP look: keep stored `winxp` readable without applying it.
  if (config?.skinPreference === "winxp") return "color";
  if (SKINS.includes(config?.skinPreference)) return config.skinPreference;

  // Pre-skin installs stored a binary light/dark preference. Their dark was
  // the grey look, which is Mono now.
  if (config?.darkModePreference === "dark") return "mono";
  if (config?.darkModePreference === "light") return "color";
  if (config?.darkMode === true) return "mono";

  return "color";
}

export function nextSkin(skin) {
  const index = SKINS.indexOf(skin);
  return SKINS[(index + 1) % SKINS.length];
}
